// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"6a944202","235":"5e90d810","239":"7147f8a2","453":"4584ce5d","746":"f836c218","929":"0c539729","941":"819f493f","992":"c8d7039e"}[chunkId] + ".chunk.js";
};